
import { Offcanvas,Modal } from 'bootstrap'
import Swiper from 'swiper';
import {
  Navigation,
  // Pagination,
  Autoplay
} from 'swiper/modules';

const swiper = new Swiper('.swiper', {
  modules: [
      Navigation,
      // Pagination,
      Autoplay
  ],
  // Optional parameters
  // direction: 'vertical',
  loop: true,

  autoplay: {
    delay: 4000,
  },

  // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination',
  // },
  //
  // // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }

  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar',
  // },
});


(function($) {

    document.addEventListener('DOMContentLoaded', function() {

        // Capture checkbox value and email before form submission
        $(document).on('submit', 'form[id^="gform_"]', function() {
            var $this = $(this);
            var formId = parseInt($this.attr('id').replace('gform_', ''), 10); // Extract form ID as an integer

            // Store checkbox state
            var isChecked = $this.find('.ginput_container_consent input[type="checkbox"]').is(':checked');
            localStorage.setItem("lead_checkbox_checked", isChecked ? "true" : "false"); // Store in localStorage

            // Capture email value before form disappears
            var emailField = $this.find('.ginput_container_email input');
            if (emailField.length) {
                var userEmail = emailField.val().trim().toLowerCase();
                localStorage.setItem("lead_email", userEmail); // Store email for use on confirmation page
            }

            console.log("🚀 Form submitted! Form ID:", formId);
            console.log("✔️ Checkbox checked?", isChecked);
            console.log("📧 Captured email:", userEmail);
        });

        // 🔥 Fire Pixel Event on Any Page Where `lead_email` Exists
        var storedEmail = localStorage.getItem("lead_email");
        var storedCheckboxChecked = localStorage.getItem("lead_checkbox_checked") === "true"; // Convert to boolean

        if (storedEmail && !storedCheckboxChecked) {
            console.warn("⚠️ Checkbox was not checked, deleting stored email.");
            localStorage.removeItem("lead_email"); // Delete stored email if checkbox was not checked
        }

        if (storedEmail && storedCheckboxChecked) { // If data exists, fire event
            console.log("✅ Gravity Form Confirmation Page Detected");
            console.log("🔍 Was checkbox checked before submission?", storedCheckboxChecked);
            console.log("📧 Retrieved stored email:", storedEmail);

            if (typeof fbq === "function") { // Check if fbq exists before calling it
                fbq('track', 'Lead', {
                    content_name: "Gravity Form Submission",
                    content_category: "Form Confirmation",
                    lead_type: "Newsletter", // Custom parameter
                    user_email: storedEmail, // Send dynamically captured email
                });
                console.log('🔥 Facebook Pixel Lead event fired with email:', storedEmail);
            } else {
                console.warn("⚠️ Facebook Pixel (fbq) is not available. Event not fired.");
            }

            // Clear stored values after firing the event to avoid duplicate tracking
            localStorage.removeItem("lead_email");
            localStorage.removeItem("lead_checkbox_checked");
        }

    });

})(jQuery);

jQuery(document).ready(function ($) {


  function showAddToCartTaylorsPopup(productName, productImage, variant, quantity, price) {

      // Find .cart-contents and position popup below it
      var $cartContents = $('.cart-contents');

      if ($cartContents.length) {

          var $popup = $('#addToCartPopup');

          // Position the popup right below .cart-contents
          var offset = $cartContents.offset();
          $popup.css({
              top: 20, // 10px space below cart-contents
              right: 20,
              display: 'block'
          }).addClass('animated');


          // Remove popup after a few seconds
          setTimeout(function () {
              closeBasketPopup();
          }, 5000); // Hide after 3 seconds

      }
  }


  // Function to close the popup
  function closeBasketPopup() {
      var $popup = $('#addToCartPopup');
      $popup.fadeOut(300, function () {
          $(this).removeClass('animated loaded');
      });
  }

  // Event listener for the dismiss button
  $(document).on('click', '#dismissAddToCartPopup', function(e) {
      e.preventDefault();
      closeBasketPopup();
  });

    $('.single_add_to_cart_button').on('click', function(e) {

        e.preventDefault(); // Prevent the default button behavior (redirect)

        var $button = $(this);
        var $form = $button.closest('form.cart');
        var quantity = $form.find('input[name=quantity]').val() || 1;
        var variationId = $form.find('input[name=variation_id]').val() || 0; // For variable products

        // AJAX request to add product to cart
        $.ajax({
            url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
            type: 'POST',
            data: {
                product_id: variationId,
                quantity: quantity
            },
            success: function(response) {
                if (response.error) {
                    console.log(response.error);
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
                    $(document.body).trigger('wc_fragment_refresh');
                }
            }
        });
    });

    $(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {

        var i = setInterval(function() {
            if ($("#addToCartPopup").hasClass("loaded")) {
                clearInterval(i);
                showAddToCartTaylorsPopup();
            }
        }, 500);

    });

});

